module.exports = "\r\n<div class=\"select-language\">\r\n  <select class=\"form-control bs-select bs-ember\" data-style=\"btn white shadow\" (change)=\"onlangChange($event.target.value)\" [(ngModel)]=\"currentLang\">\r\n    <option disabled value=\"Select an Office\">{{\"SELECT_LANGUAGE\" | translate}}</option>\r\n    <option [selected]=\"language==lang.value\" *ngFor=\"let lang of languages\" [value]=\"lang.value\">{{lang.name}}</option>\r\n  </select>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/slots/header/header.component.html
// module id = ./src/app/slots/header/header.component.html
// module chunks = main